import { render, staticRenderFns } from "./referee_home.vue?vue&type=template&id=6446df3a&scoped=true"
import script from "./referee_home.vue?vue&type=script&lang=js"
export * from "./referee_home.vue?vue&type=script&lang=js"
import style0 from "./referee_home.vue?vue&type=style&index=0&id=6446df3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446df3a",
  null
  
)

export default component.exports